function WebskedTimeModalController(
  $scope,
  $log,
  $translate,
  storyProcessingService,
  toastWrapperService,
  $uibModalInstance,
  timezoneService,
  moment
) {
  $scope.showMeridian = timezoneService.userTimeHourFormat === 12;
  $scope.getDisplayTime = () => {
    const date = new Date($scope.story.dates.webskedDateUpdate);
    const time = new Date($scope.story.dates.webskedTimeUpdate);
    const datetime = new Date(
      date.getFullYear(), date.getMonth(), date.getDate(), time.getHours(), time.getMinutes(), 0
    );
    return moment(datetime)
      .format(timezoneService.userTimeHourFormat === 12 ? 'L h:mm a' : 'L H:mm');
  };
  $scope.datepickerTimezone = timezoneService.userUTCOffset;
  $scope.datepickerOptions = {
    timezone: timezoneService.userTimezone
  };
  // Method for closing modal with failure results
  $scope.closeModal = () => {
    $uibModalInstance.dismiss('cancel');
  };

  $scope.saving = {
    enable: false
  };

  $scope.updateEta = () => {
    $scope.saving.enable = true;

    const date = new Date($scope.story.dates.webskedDateUpdate);
    const time = new Date($scope.story.dates.webskedTimeUpdate);
    const localDate = new Date(
      date.getFullYear(), date.getMonth(), date.getDate(), time.getHours(), time.getMinutes(), 0
    );
    const tzDate = new Date(localDate.toLocaleString('en-US', {
      timeZone: timezoneService.userTimezone
    }));

    const diff = localDate.getTime() - tzDate.getTime();

    const updatedEtaDateObj = new Date(localDate.getTime() + diff);
    const updatedEta = updatedEtaDateObj.getTime() / 1000;

    storyProcessingService.updateEta($scope.story, updatedEtaDateObj)
      .then(() => {
        if (!$scope.story.dates.websked) {
          $scope.story.webskedTimeUpdated = true;
        }

        $scope.story.dates.planned = updatedEta;
        $scope.story.dates.websked = updatedEta;

        // Closing modal with success (for failure use dismiss)
        $uibModalInstance.close();

        toastWrapperService.createToast($translate.instant('SUCCESS'), 'success');
      }, (response) => {
        $scope.saving.enable = false;

        $log.error('WebskedTimeController storyProcessingService.updateEta() error: ', response.error || response);

        toastWrapperService.createToast($translate.instant('ERROR_ETA_UPDATE'), 'danger');
      });
  };
}

const ctrlArr = [
  '$scope',
  '$log',
  '$translate',
  'storyProcessingService',
  'toastWrapperService',
  '$uibModalInstance',
  'timezoneService',
  'moment',
  WebskedTimeModalController
];

export default function (ngModule) {
  ngModule.controller('WebskedTimeModalController', ctrlArr);
}
